/**
 * Putt Broadie Drill 10FT Reducers
 */
import {
    PUTTBDTENPOINTS_ACTION,
    ALL_PUTTBDTENPOINTS,
    ADD_PUTTBDTENPOINTS,
    ALL_PUTTBDTENPUTTS,
    ADD_PUTTBDTENPUTTS,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    puttbdtenpointlist:[],
    puttbdtenputtlist:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PUTTBDTENPOINTS_ACTION:
            return { ...state, loading: true };       

        case ALL_PUTTBDTENPOINTS:
            return { ...state, loading: false, puttbdtenpointlist: action.payload };     
            
        case ADD_PUTTBDTENPOINTS:
            return { ...state, loading: false }; 
            
        case ALL_PUTTBDTENPUTTS:
            return { ...state, loading: false, puttbdtenputtlist: action.payload };     
            
        case ADD_PUTTBDTENPUTTS:
            return { ...state, loading: false }; 

        default: return { ...state };

     }
 }